import FullScreenDialog from '../full-screen-dialog/FullScreenDialog';
import SettingsBar from '../settings-bar/SettingsBar';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import MobileOrganizationHierarchy from '../organization-hierarchy/mobile/MobileOrganizationHierarchy';
import { IOrganization } from '../../services/organization-data-service/Models';
import WithIsLoadingHOC from "../../hocs/is-loading-hoc/IsLoadingHOC";

const MobileOrganizationHierarchyWithLoading = WithIsLoadingHOC(MobileOrganizationHierarchy);

export type MobileOrganizationPickerProps = {
    includeAllOption?: boolean;
    open: boolean;
    onClose: (item?: IOrganization) => void,
    organizationID: number
};

export default function MobileOrganizationPicker({
    includeAllOption,
    organizationID,
    open, 
    onClose
}: MobileOrganizationPickerProps) {
    
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);    

    const onSelected = (item: IOrganization): void => {

        if (onClose) {
            onClose(item);
        }
    };


    return (

        <FullScreenDialog open={open} onClose={() => onClose()}>

                <SettingsBar title={t('navigation.organizations')} 
                            onClose={() => onClose()}
                            hideAction={true}
                             />                

                    <MobileOrganizationHierarchyWithLoading 
                        isLoading={loading}
                        onLoading={setLoading}                    
                        onSelected={onSelected} 
                        organizationID={organizationID}
                        includeAllOption={includeAllOption}
                         />

        </FullScreenDialog>
    );
}
